/* Clarity events use fixed names only and require Shopify analytics consent. */
(() => {
  const analyticsConsentGranted = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function') {
      return privacy.analyticsProcessingAllowed() === true;
    }
    return typeof privacy?.userCanBeTracked === 'function' && privacy.userCanBeTracked() === true;
  };

  window.dopeClarityEvent = (name) => {
    if (window.Shopify?.designMode || !analyticsConsentGranted() || typeof window.clarity !== 'function') return false;
    if (!['dope_lookbook_open', 'dope_lookbook_shop', 'dope_add_to_cart_success', 'dope_add_to_cart_error', 'dope_checkout_click', 'dope_offer_details_open', 'dope_home_shop', 'dope_product_discovery', 'dope_finder_product', 'dope_finder_approval', 'dope_finder_venue', 'dope_finder_price', 'dope_finder_budget', 'dope_finder_unavailable', 'dope_finder_explore', 'dope_faq_search', 'dope_faq_no_results', 'dope_faq_answer_open', 'dope_faq_contact', 'dope_faq_helpful', 'dope_faq_not_helpful'].includes(name)) return false;
    try {
      window.clarity('event', name);
      return true;
    } catch {
      // Measurement must never interrupt the customer's shopping action.
      return false;
    }
  };

  document.addEventListener('ajaxProduct:added', () => {
    window.dopeClarityEvent('dope_add_to_cart_success');
  });

  document.addEventListener('ajaxProduct:error', () => {
    window.dopeClarityEvent('dope_add_to_cart_error');
  });

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest?.('button[name="checkout"], input[name="checkout"]');
    if (checkoutButton && !checkoutButton.disabled) window.dopeClarityEvent('dope_checkout_click');
    const discovery = event.target.closest?.('[data-dope-discovery]');
    const name = {home_shop: 'dope_home_shop', product: 'dope_product_discovery', finder_product: 'dope_finder_product'}[discovery?.dataset?.dopeDiscovery];
    if (name) window.dopeClarityEvent(name);
  }, true);

  // <details> toggle does not bubble, so capture it to cover replaced cart sections too.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (details?.tagName?.toLowerCase() !== 'details' || !details.open || !details.closest?.('.dope-offer')) return;
    window.dopeClarityEvent('dope_offer_details_open');
  }, true);
})();
